type Elements = {
  1: string;
  2: string;
  3: string;
};

export const Difficulty_Levels: Elements | any = {
  1: "Easy",
  2: "Medium",
  3: "Hard",
};
